import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";

export const StyledListItem = withStyles({
  root: {
    "&.Mui-selected": {
      backgroundColor: "transparent",
      // borderRight: "solid 3px #EF7713",
    },
  },
})(ListItem);
